{
  "colorInputLabel": "{label}, {channelLabel}",
  "colorNameAndValue": "{name}: {value}",
  "colorPicker": "Färgväljaren",
  "twoDimensionalSlider": "2D-reglage"
}
